import { resolveParticipantLabel } from './participantLabel';
import type { TeamEntry } from './teamLabels';

/**
 * Pure naming helper for the public Matches rows (`buildMatchRow`), split out so
 * the ladder (team → alias → script-aware personal name, with the lucky-loser
 * placeholder/suffix layered on top) is unit-testable without mounting a component.
 */

type NamedPlayer = { first_name: string; last_name: string; alias?: string | null };

/**
 * The single-string side label used by `buildMatchRow`. Lucky-loser placeholder
 * wins outright; otherwise team → alias → script-aware personal name
 * (`resolveParticipantLabel`), with the assigned-LL " L" suffix appended last.
 */
export function resolveEventMatchOpponentName({
  player,
  isLuckyLoserPlaceholder,
  luckyLoserLabel,
  entry,
  isAssignedLuckyLoser,
  isJapanese,
}: {
  player: NamedPlayer | null | undefined;
  isLuckyLoserPlaceholder: boolean;
  luckyLoserLabel: string;
  entry?: TeamEntry | null;
  isAssignedLuckyLoser: boolean;
  isJapanese: boolean;
}): string | null {
  if (!player) return null;
  if (isLuckyLoserPlaceholder) return luckyLoserLabel;
  const label = resolveParticipantLabel({ entry, player, isJapanese });
  return isAssignedLuckyLoser ? `${label} L` : label;
}
